import { SurveyProvider } from '../SurveyProvider';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class SurveyProviderFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/survey`, headers);
  }

  public createSurveyProvider(token: string): SurveyProvider {
    return new SurveyProvider(this.apiClientFactory.createAuthorizedClient(token));
  }
}
